package features.home.ui.components

import kotlinx.html.*
import AppState
import features.attendance.helpers.AttendanceHelpers

object DashboardCard {
    fun render(parent: DIV) {
        val userId = AppState.currentUser?.id ?: return
        
        // AppState.teams already contains only teams where user is a member
        val userTeams = AppState.teams
        
        if (userTeams.isEmpty()) return
        
        // Check if user is admin in any team
        val isAdminInAnyTeam = userTeams.any { team ->
            AttendanceHelpers.isAdminOrOwner(userId, team.id)
        }
        
        parent.div {
            // Always show Team Selector so everyone can clock in/out
            TeamSelector.render(this)
            
            // Query Tester removed - only for debugging
            // QueryTester.render(this)
            
            if (isAdminInAnyTeam) {
                // Show admin view for first admin team (management view)
                val adminTeam = userTeams.first { team ->
                    AttendanceHelpers.isAdminOrOwner(userId, team.id)
                }
                AdminScheduleCard.render(this, adminTeam.id)
            }
        }
    }
}
